export const getPromoCode = (): string | null => {
  return localStorage.getItem("promo_code")
}

export const clearPromoCode = () => {
  localStorage.removeItem("promo_code")
}
